import type { RouteObject } from 'react-router';
import { ExpectedReturnsPage } from './pages/ExpectedReturnsPage';
import { ReceiveTruckPage } from './pages/ReceiveTruckPage';

/** Placed under `/yard` in `YardLayout` by the router. */
export const YARD_ROUTES: RouteObject[] = [
  { index: true, element: <ExpectedReturnsPage /> },
  { path: 'receive/:tripId', element: <ReceiveTruckPage /> },
];
